export default __webpack_public_path__ + "static/media/allgemein_37.eff4603a.jpg";